"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.normalizeWorkspaceRefusalReason = exports.workspaceRefusalRetryable = exports.workspaceRefusalCategory = exports.NO_LIVE_GRANT_SENTENCE = exports.WORKSPACE_NOT_READY_SENTENCE = exports.UNKNOWN_WORKSPACE_REFUSAL = exports.WORKSPACE_REFUSAL_CATEGORIES = void 0;
const mounts_1 = require("./mounts");
const submitRefusals_1 = require("./submitRefusals");
exports.WORKSPACE_REFUSAL_CATEGORIES = [
    "quota",
    "ceiling",
    "mount_policy",
    "access",
    "environment",
    "scheduler",
    "request",
];
exports.UNKNOWN_WORKSPACE_REFUSAL = "unknown_refusal";
exports.WORKSPACE_NOT_READY_SENTENCE = /^workspace is [a-z_]+, and only a ready workspace accepts jobs$/;
exports.NO_LIVE_GRANT_SENTENCE = "no live grant governs this requester on the workspace's run environment";
const BIND_PROBE_REFUSAL_CODES = [
    "no_path_oracle",
    "agent_refused",
    "not_found",
    "unsafe_resolved_path",
    "outside_root_after_resolution",
    "touches_private_path",
    "touches_workspace_base",
    "has_submount",
    "overlapping_after_resolution",
];
const AGENT_MOUNT_REFUSAL_CODES = [
    "mount_roots_unset",
    "mount_roots_invalid",
    "mount_table_unreadable",
    "host_path_unresolvable",
    "host_path_changed",
    "outside_agent_base_path",
    "outside_mount_roots",
    "mode_exceeds_mount_root",
    "control_path",
    "submount_on_login_node",
    "autofs_on_login_node",
];
const CATEGORY_CODES = {
    quota: [
        "live_workspaces",
        "live_jobs",
        "window_cpu",
        "storage",
        "chain_depth",
        "waiting_steps",
        "local_host_busy",
    ],
    ceiling: ["job_wall_time", "job_larger_than_window"],
    mount_policy: [
        ...mounts_1.MOUNT_REFUSAL_REASONS,
        "overlaps_workspace_tree",
        ...BIND_PROBE_REFUSAL_CODES,
        ...AGENT_MOUNT_REFUSAL_CODES,
    ],
    access: [
        "workspace_not_found",
        "workspace_not_ready",
        "no_live_grant",
        "workspace_mismatch",
        "workspace_not_accepting",
    ],
    environment: [
        "not_configured",
        "container_runtime_not_configured",
        "environment_gone",
        "environment_unbound",
        "agent_not_attached",
        "agent_offline",
        "workspace_scheduler_unsupported",
        "workspace_jobs_disabled",
        "workspace_jobs_unavailable",
        "ssh_execution_disabled",
        "bind_probe_unavailable",
        "control_dir_unwritable",
        "workspace_layout",
        "venue_not_supported",
        "local_limits_unavailable",
        "docker_daemon_in_vm",
        "docker_endpoint_refused",
        "local_execution_needs_local_executor",
    ],
    scheduler: ["scheduler_refused"],
    request: [
        "invalid_input",
        "invalid_request",
        "invalid_directive",
        "control_file_invalid",
        "chains_disabled",
        "after_not_found",
        "after_self",
        "hold_needs_after",
        "when_needs_after",
        "chain_step_skipped",
        "submission_key_reserved",
        "invalid_declared_resources",
    ],
};
const CATEGORY_OF = new Map(exports.WORKSPACE_REFUSAL_CATEGORIES.flatMap((category) => CATEGORY_CODES[category].map((code) => [code, category])));
const RETRYABLE_CODES = new Set([
    "live_jobs",
    "waiting_steps",
    "local_host_busy",
    "window_cpu",
    "bind_probe_unavailable",
    "agent_offline",
    "dispatch_capacity",
    "dispatch_queue_expired",
    "dispatch_shutting_down",
]);
const workspaceRefusalCategory = (reason) => { var _a; return (_a = CATEGORY_OF.get(reason)) !== null && _a !== void 0 ? _a : "environment"; };
exports.workspaceRefusalCategory = workspaceRefusalCategory;
const workspaceRefusalRetryable = (reason) => RETRYABLE_CODES.has(reason);
exports.workspaceRefusalRetryable = workspaceRefusalRetryable;
const AGENT_SUMMARY_PREFIX = "refused:";
const CODE_PREFIX = /^([a-z_]+)(?::\s*(?:mount ([0-9]+) \()?|$|\s)/;
const normalizeWorkspaceRefusalReason = (raw) => {
    const text = typeof raw === "string" ? raw : "";
    if (exports.WORKSPACE_NOT_READY_SENTENCE.test(text))
        return { reason: "workspace_not_ready", mount: null };
    if (text === exports.NO_LIVE_GRANT_SENTENCE)
        return { reason: "no_live_grant", mount: null };
    const summary = (0, submitRefusals_1.parseWorkspaceSubmitRefusal)(text);
    if (summary !== null)
        return { reason: summary.code, mount: summary.index };
    const match = CODE_PREFIX.exec(text.startsWith(AGENT_SUMMARY_PREFIX)
        ? text.slice(AGENT_SUMMARY_PREFIX.length)
        : text);
    if (match === null)
        return { reason: exports.UNKNOWN_WORKSPACE_REFUSAL, mount: null };
    const mount = match[2] === undefined ? null : Number(match[2]);
    return {
        reason: match[1],
        mount: mount !== null && Number.isSafeInteger(mount) ? mount : null,
    };
};
exports.normalizeWorkspaceRefusalReason = normalizeWorkspaceRefusalReason;
